import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCompMst: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.cpnyScn !== undefined || searchParams.cpnyNm !== undefined || searchParams.useYn !== undefined) {
			queryStr = objectToQueryString({
				cpnyScn: searchParams.cpnyScn,
				cpnyNm: searchParams.cpnyNm,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/qmsbase/compMst/v1/compMsts` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// 저장
	async postCompMst({ saveParams }) {
		try {
			const response = await client.post(`${BASE_URL}/comm/qmsbase/compMst/v1/status/2`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getUserName: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.cpnyScn !== undefined || searchParams.cpnyNm !== undefined || searchParams.crgrNm !== undefined) {
			queryStr = objectToQueryString({
				cpnyScn: searchParams.cpnyScn,
				cpnyCd: searchParams.cpnyCd,
				crgrNm: searchParams.crgrNm,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/qmsbase/compMst/v1/compMstUser` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
